// API Configuration
// export const API_BASE_URL = 'https://realairschedule-337716927225.us-east4.run.app';
export const API_BASE_URL = 'https://realairschedule-live-337716927225.us-east4.run.app';

// export const API_BASE_URL = 'http://localhost:3000';
// export const API_BASE_URL = 'http://10.0.0.108:3001';

// Support Configuration
export const SUPPORT_EMAIL = 'leo@realairadventures.com'; 